module.exports = __webpack_public_path__ + "img/UI_shouji_AP_01_ad9a8bf5d.png";